/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SolarOverrideTask
 */
export interface SolarOverrideTask {
    /**
     *
     * @type {number}
     * @memberof SolarOverrideTask
     */
    connectorIndex?: number;
    /**
     *
     * @type {number}
     * @memberof SolarOverrideTask
     */
    transactionId?: number;
    /**
     *
     * @type {number}
     * @memberof SolarOverrideTask
     */
    maxImportKw?: number;
}

/**
 * Check if a given object implements the SolarOverrideTask interface.
 */
export function instanceOfSolarOverrideTask(
    value: object,
): value is SolarOverrideTask {
    return true;
}

export function SolarOverrideTaskFromJSON(json: any): SolarOverrideTask {
    return SolarOverrideTaskFromJSONTyped(json, false);
}

export function SolarOverrideTaskFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): SolarOverrideTask {
    if (json == null) {
        return json;
    }
    return {
        connectorIndex:
            json["connectorIndex"] == null ? undefined : json["connectorIndex"],
        transactionId:
            json["transactionId"] == null ? undefined : json["transactionId"],
        maxImportKw:
            json["maxImportKw"] == null ? undefined : json["maxImportKw"],
    };
}

export function SolarOverrideTaskToJSON(value?: SolarOverrideTask | null): any {
    if (value == null) {
        return value;
    }
    return {
        connectorIndex: value["connectorIndex"],
        transactionId: value["transactionId"],
        maxImportKw: value["maxImportKw"],
    };
}
